import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Navbar } from "@components/Navbar";
import { AuthProvider } from "@lib/auth-client";
import { HomePage } from "@pages/Home";
import { LoginPage } from "@pages/Login";
import { ProductPage } from "@pages/Product";
import { ComparePage } from "@pages/Compare";
import { AdminPage } from "@pages/Admin";
import "./styles.css";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <Navbar />
          <main className="app-main">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/product/:slug" element={<ProductPage />} />
              <Route path="/compare" element={<ComparePage />} />
              <Route path="/compare/:pair" element={<ComparePage />} />
              <Route path="/admin" element={<AdminPage />} />
            </Routes>
          </main>
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
